import axios from 'axios'

export const HTTP_MODE = {
  API: 'api',
  STANDALONE: 'standalone'
} as const
type Mode = (typeof HTTP_MODE)[keyof typeof HTTP_MODE]

class HttpService {
  private mode: Mode

  constructor () {
    this.mode = HTTP_MODE.API
  }

  get isStandalone () {
    return this.mode === HTTP_MODE.STANDALONE
  }

  initialize (mode = HTTP_MODE.API) {
    this.mode = mode
    this.setDefaults()
    this.setInterceptors()
  }

  setDefaults () {
    axios.defaults.baseURL = this.getBaseURL()
    axios.defaults.withCredentials = true
  }

  getBaseURL () {
    if (this.isStandalone) {
      return ''
    }
    const host = __CONFIG__.apiHost || window.location.hostname
    const port = __CONFIG__.apiPort || window.location.port
    return `//${host}:${port}/`
  }

  async checkResourceExists (url) {
    try {
      const response = await axios.get(url)
      return response.status === 200
    } catch (e) {
      return false
    }
  }

  private setInterceptors () {
    axios.interceptors.response.use(
      (response) => response,
      async (error) => {
        if (
          error.response &&
          error.response.status >= 400 &&
          error.response.status <= 500 &&
          error.response.data?.message
        ) {
          error.message = error.response.data.message
        }
        return Promise.reject(error)
      }
    )
  }
}

export const httpService = new HttpService()
